import { __awaiter, __generator } from "tslib";
import { getFetchManyEntitiesUrl } from '../utilities/get-fetch-many-entities-url';
import { fetchGetProductCatalogue } from './fetch-get-product-catalogue';
/**
 * @internal
 */
export var fetchManyEntities = function (entityIds, productType, includeType) {
    if (includeType === void 0) { includeType = "available" /* Available */; }
    return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getFetchManyEntitiesUrl(entityIds, productType, includeType);
                    return [4 /*yield*/, fetchGetProductCatalogue(url)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
